import { render, staticRenderFns } from "./viewDigitalSignage.vue?vue&type=template&id=8cdf8288"
import script from "./viewDigitalSignage.ts?vue&type=script&lang=ts&external"
export * from "./viewDigitalSignage.ts?vue&type=script&lang=ts&external"
import style0 from "./viewDigitalSignage.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports